import type { MenuItem } from '@velasca/types'

interface Map {
  placeholder: string
  value: string
}

const replace = (menu: MenuItem, map: Map[]) => {
  const { url } = menu
  const substitute = map.find(({ placeholder }) => placeholder === url)

  if (url && substitute) {
    // Menu url contains a placeholder
    return {
      ...menu,
      url: substitute.value,
    }
  }

  // Menu url doesn't contain a placeholder and it's already a link
  return menu
}

const replaceChildren = (menu: MenuItem, map: Map[]): MenuItem => {
  if (menu.children) {
    return {
      ...replace(menu, map),
      children: menu.children.map((child) => replaceChildren(child, map)),
    }
  }

  return replace(menu, map)
}

export default function renderLiquidLink(menu: MenuItem[], map: Map[]) {
  if (!menu || !map) {
    return null
  }

  return menu.map((newMenu) => replaceChildren(newMenu, map))
}
